module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst attributes = ((((storage || {}).request || {}).event || {}).data || {}).attributes || {}\nconst eventAttributes = attributes.event || {}\nconst eventPartAttributes = (attributes.eventParts || {})[Object.keys(attributes.eventParts || {})[0] || 'NO_EVENT_PART_LANG_CODE'] || {}\nconst eventStatus = eventAttributes.status || 'draft'\nconst userIsInPreviewMode = storage.user.statusVisible('preview') || false\nconst loaderError = model.error\nconst registrationFormGranted = (\n!loaderError\n&&\n(\neventStatus === 'live'\n||\n(\neventStatus === 'draft'\n&&\nuserIsInPreviewMode\n)\n)\n)\n%><div><%\nif(userIsInPreviewMode){\n%><div class=\"preview\"><%= storage.__('events.registration.previewMode') %></div><%\n}\nif(registrationFormGranted){\n%><h2><%= storage.__('events.registration.headlines.main') %></h2><%\n/*\nif(eventPartAttributes.title){\n%><h1><%#= eventPartAttributes.title %></h1><%\n}\nif(eventPartAttributes.subTitle){\n%><h2><%#= eventPartAttributes.subTitle %></h2><%\n}\nif(eventAttributes.startTS && eventAttributes.endTS){\n%><h3><%#= utils.moment(eventAttributes.startTS).format('DD.MM.YYYY') %> - <%= utils.moment(eventAttributes.endTS).format('DD.MM.YYYY') %></h3><%\n}\n*/\n%><section class=\"messageContainer\">\n<div class=\"message\"></div>\n</section><%\n%><%- helpers.renderSection('forms') %><%\n} else if(config.isPostAuth){\n%><section class=\"messageContainer\">\n<div class=\"message\"></div>\n</section><%\n}\n%></div>"
  , __filename = "..\\frontend-controller\\baseComponents\\bootstrap5\\events\\registrationFormController.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const attributes = ((((storage || {}).request || {}).event || {}).data || {}).attributes || {}
const eventAttributes = attributes.event || {}
const eventPartAttributes = (attributes.eventParts || {})[Object.keys(attributes.eventParts || {})[0] || 'NO_EVENT_PART_LANG_CODE'] || {}
const eventStatus = eventAttributes.status || 'draft'
const userIsInPreviewMode = storage.user.statusVisible('preview') || false
const loaderError = model.error
const registrationFormGranted = (
!loaderError
&&
(
eventStatus === 'live'
||
(
eventStatus === 'draft'
&&
userIsInPreviewMode
)
)
)

    ; __line = 21
    ; __append("<div>")
    ; 
if(userIsInPreviewMode){

    ; __line = 23
    ; __append("<div class=\"preview\">")
    ; __append(escapeFn( storage.__('events.registration.previewMode') ))
    ; __append("</div>")
    ; 
}
if(registrationFormGranted){

    ; __line = 26
    ; __append("<h2>")
    ; __append(escapeFn( storage.__('events.registration.headlines.main') ))
    ; __append("</h2>")
    ; 
/*
if(eventPartAttributes.title){

    ; __line = 29
    ; __append("<h1>")
    ; __append("</h1>")
    ; 
}
if(eventPartAttributes.subTitle){

    ; __line = 32
    ; __append("<h2>")
    ; __append("</h2>")
    ; 
}
if(eventAttributes.startTS && eventAttributes.endTS){

    ; __line = 35
    ; __append("<h3>")
    ; __append(" - ")
    ; __append(escapeFn( utils.moment(eventAttributes.endTS).format('DD.MM.YYYY') ))
    ; __append("</h3>")
    ; 
}
*/

    ; __line = 38
    ; __append("<section class=\"messageContainer\">\n<div class=\"message\"></div>\n</section>")
    ; __line = 40
    ; 

    ; __line = 41
    ; __append( helpers.renderSection('forms') )
    ; 
} else if(config.isPostAuth){

    ; __line = 43
    ; __append("<section class=\"messageContainer\">\n<div class=\"message\"></div>\n</section>")
    ; __line = 45
    ; 
}

    ; __line = 47
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\bootstrap5\events\registrationFormController.ejs

}